import { Instance } from "mobx-state-tree";
import { AuditLogsStore } from "./AuditLogsStore";
import { useProjectsRootStore } from "../../store/Hooks";

export const useAuditLogsStore = (): Instance<typeof AuditLogsStore> => {
  return useProjectsRootStore().auditLogsStore;
};
